import { getGameformatGroup } from '@/store/gameformat/gameformat'
import store from '@/store'
import { ref } from 'vue'

export function getGmfUtils() {
  const gmf_loading = ref(false)

  const gmf_fetchGmfAndReturnStatus = async gametype => {
    const mode = getGameformatGroup(gametype, 'Cash')
    if (!store.getters.gameformats_groupsSet[mode]) {
      gmf_loading.value = true
      const result = await store.dispatch('get_gameformat_groups', [mode])
      gmf_loading.value = false
      if (!result || result.error) return 'error'
    }
    return 'continue'
  }

  return {
    gmf_fetchGmfAndReturnStatus,
    gmf_loading,
  }
}
